// navigationService.js
let navigateFunction = null;

export const setNavigate = (nav) => {
  navigateFunction = nav;
};

export const getNavigate = () => navigateFunction;
